import { get } from './shared';

export const initialize = get(`/:paymentId/experience/result/manualBankTransfer`);
